import prepareComponent from "@bluframe/grapple/prepareComponent"
import { useCallback } from "react"

import ThumbnailButton from "./ThumbnailButton"

interface Props {
  activeIndex: number
  children: React.ReactNode
  index: number

  onSelectIndex: (index: number) => void

  onThumbnailPress?: (index: number) => void
}

export interface ComponentProps extends Omit<
  Props,
  "onSelectIndex" | "onThumbnailPress"
> {
  isPressed: boolean
  onClick: () => void
}

export const usePrepareComponent = ({
  onSelectIndex,
  onThumbnailPress,
  ...props
}: Props): ComponentProps => {
  const onClick = useCallback(() => {
    onSelectIndex(props.index)
    onThumbnailPress?.(props.index)
  }, [onSelectIndex, onThumbnailPress, props.index])

  return {
    ...props,
    isPressed: props.activeIndex === props.index,
    onClick
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  ThumbnailButton
)
